import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7f5da944"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=7f5da944&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/test-tripanels/clusterpanels/client-panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f5da944')) {
      api.createRecord('7f5da944', component.options)
    } else {
      api.reload('7f5da944', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7f5da944", function () {
      api.rerender('7f5da944', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NumberInput/index.vue"
export default component.exports